import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "distributeoptions"
    }}>{`DistributeOptions`}</h1>
    <p>{`Options for distributing objects.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LEFT_EDGES`}</strong>{` = 1281770852`}</p>
      <p parentName="blockquote">{`Distribute based on the left edges of the objects.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TOP_EDGES`}</strong>{` = 1416643940`}</p>
      <p parentName="blockquote">{`Distribute based on the top edges of the objects.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`RIGHT_EDGES`}</strong>{` = 1383351652`}</p>
      <p parentName="blockquote">{`Distribute based on the right edges of the objects.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`BOTTOM_EDGES`}</strong>{` = 1114916196`}</p>
      <p parentName="blockquote">{`Distribute based on the bottom edges of the objects.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`HORIZONTAL_CENTERS`}</strong>{` = 1215257187`}</p>
      <p parentName="blockquote">{`Distribute based on the horizontal centers of the objects.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`VERTICAL_CENTERS`}</strong>{` = 1449481315`}</p>
      <p parentName="blockquote">{`Distribute based on the vertical centers of the objects.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`HORIZONTAL_SPACE`}</strong>{` = 1215257203`}</p>
      <p parentName="blockquote">{`Distribute based on the horizontal spacing of the objects.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`VERTICAL_SPACE`}</strong>{` = 1449489523`}</p>
      <p parentName="blockquote">{`Distribute based on the vertical spacing of the objects.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      